"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTranslationsWithNamespaces = fetchTranslationsWithNamespaces;
var _fetching = require("@ori/fetching");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _mergeTranslations = require("./mergeTranslations");
/**
 * Fetches translations with namespaces from the specified API endpoint for different packages.
 *
 * @typeParam T Type of the translations object.
 * @param options Fetch options.
 * @returns  Promise resolving to the fetched translations.
 */
async function fetchTranslationsWithNamespaces({
  currentLanguage,
  language,
  defaultTranslationsWithNamespaces,
  clientFetchConfiguration,
  onError
}) {
  const {
    tenant,
    baseUrl = window.location.origin
  } = clientFetchConfiguration;
  let translationsWithNamespaces = JSON.parse(JSON.stringify(defaultTranslationsWithNamespaces)); // Creates deep copy of default translations

  const staticApiClient = new _staticApiClientReact.ApiClient({
    baseUrl,
    language: language ?? currentLanguage ?? '',
    tenant,
    camelcaseKeysOptions: {
      stopPaths: ['Localizations']
    }
  });
  const getPackageTranslations = async packageId => {
    const response = await (0, _staticApiClientReact.getTenantLocalization)(staticApiClient, tenant, packageId, {
      lang: language ?? currentLanguage ?? ''
    });
    return (0, _fetching.handleResponse)(response, {
      onSuccess: ({
        data
      }) => data.localizations,
      onError: result => {
        onError(result);
        return {};
      }
    });
  };
  const getTranslations = async () => Promise.all(Object.keys(defaultTranslationsWithNamespaces).map(async packageId => {
    const packageTranslations = await getPackageTranslations(packageId);
    translationsWithNamespaces = (0, _mergeTranslations.mergeTranslations)(translationsWithNamespaces, packageTranslations, packageId);
  }));
  try {
    await getTranslations();
  } catch (error) {
    onError(error);
    return {
      error: error,
      translationsWithNamespaces
    }; // Returns default translations when api fails
  }
  return {
    translationsWithNamespaces
  };
}
//# sourceMappingURL=fetchTranslationsWithNamespaces.js.map